<script>
  import aprovarpesquisaprecoServico from '../servico.js';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';
  import { checkbox } from 'vue-strap';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalAprovarPesquisa from '~componentes/ModalAprovarPesquisa.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';

  export default {
    components: { Cabecalho, Barcode, checkbox, ModalAprovarPesquisa, ModalMensagem, ModalArquivosSolicitacao, },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        solicitacaoSelecionada: null,
        modalMensagem: false,
        modalAprovarPesquisa: false,
        salvandoAprovacao: false,
        modalArquivos: false,
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        aprovarpesquisaprecoServico
          .obterPorIdRelatorio(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          })
          .catch(erro => {
            let msg = erro.message;           
          });

      },
      marcar: function (idItemCompra, idPesquisa, marcado) {
        if (marcado == "0")
          return;

        for (var i = 0; i < this.solicitacao.itens.length; i++) {
          if (this.solicitacao.itens[i].idItemCompra == idItemCompra) {
            for (var j = 0; j < this.solicitacao.itens[i].pesquisas.length; j++) {
              if (this.solicitacao.itens[i].pesquisas[j].idPesquisa != idPesquisa) {
                this.solicitacao.itens[i].pesquisas[j].pesquisaValidada = false;
              }
            }

            break;
          }
        }
      },
      validarMarcacao: function () {
        var algumMarcado = false;

        for (var i = 0; i < this.solicitacao.itens.length; i++) {
          for (var j = 0; j < this.solicitacao.itens[i].pesquisas.length; j++) {
            if ((this.solicitacao.itens[i].pesquisas[j].pesquisaValidada == true) || (this.solicitacao.itens[i].pesquisas[j].pesquisaValidada == 'true')) {
              algumMarcado = true;
              break;
            }           
          }

          if (algumMarcado)
            break;
        }

        return algumMarcado;
      },
      mostrarModalAprovarPesquisa(solicitacao) {
        if (!this.validarMarcacao()) {

          this.$swal(
            '',
            'É necessário selecionar pelo menos uma pesquisa de preço.',
            'info'
          );

          return;
        }

        this.solicitacaoSelecionada = solicitacao;
        this.modalAprovarPesquisa = true;
      },
      modalAprovarPesquisaFechado() {
        this.animated = false;
        this.modalAprovarPesquisa = false;
        this.solicitacaoSelecionada = null;
      },
      aprovar() {
        this.modalAprovarPesquisa = false;

        return aprovarpesquisaprecoServico
          .aprovar(this.solicitacao)
          .then(() => {
            toastr.success(`Pesquisa de preço aprovada com sucesso.`);
            $('body').removeClass('modal-open');

            this.$router.push({ name: 'aprovar-pesquisa-preco' });
          })
          .catch(erro => {
            if (erro.status === 422) {
              toastr.error(erro.body.message);
              this.$router.push({ name: 'aprovar-pesquisa-preco' });
            } else {
              this.$swal('', 'Ocorreu um erro ao tentar aprovar a pesquisa de preço.', 'error');
            }
          });
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },   
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.dataInicioVigencia;
        let dataTermino = this.solicitacao.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }
        
        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }
        
        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Aprovação Pesquisa de Preço - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'aprovar-pesquisa-preco';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">

      <modal-aprovar-pesquisa :mostrar="modalAprovarPesquisa"
                              :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                              :salvando="salvandoAprovacao"
                              @fechado="modalAprovarPesquisaFechado"
                              @aprovar="aprovar">
      </modal-aprovar-pesquisa>

      <modal-mensagem :mostrar="modalMensagem"
                      :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                      :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                      tipo="SolCompra"
                      @fechado="modalMensagensFechado">
      </modal-mensagem>

      <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                  :id="solicitacaoSelecionada ? solicitacaoSelecionada.idCompra : ''"
                                  tipo="pesquisapreco"
                                  @fechado="modalArquivosFechado">
      </modal-arquivos-solicitacao>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">

              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Aprovação Pesquisa de Preço - Relatório'"></cabecalho>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.nomeProjeto ? solicitacao.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.nomeTipoProjeto ? solicitacao.nomeTipoProjeto : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.nrProcesso ? solicitacao.nrProcesso : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoCompra || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacaoCompra | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.pedidoPor ? solicitacao.pedidoPor : '---'  }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.nomeCoordenador ? solicitacao.nomeCoordenador : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Nome contato</dt>
                    <dd>{{ solicitacao.nomeSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Email contato</dt>
                    <dd>{{ solicitacao.emailSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Telefone contato</dt>
                    <dd>{{ solicitacao.telefoneSolicitante || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
                  <dl class="col-xs-12">
                    <dt>Detalhe rateio</dt>
                    <dd>{{ solicitacao.detalheRateio ? solicitacao.detalheRateio.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.selecaoDeContaWeb">
                  <dl class="col-xs-12">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[solicitacao.alteracaoLocalEntrega ? 'col-xs-6' : 'col-xs-12']">
                    <dt>Local de entrega</dt>
                    <dd>{{ solicitacao.localEntrega.replace(/=\|=/g, ' - ') }}</dd>
                  </dl>
                  <dl class="col-xs-6" v-if="solicitacao.alteracaoLocalEntrega">
                    <dt>Justificativa de alteração do Local de Entrega</dt>
                    <dd class="white-space-pre">{{ solicitacao.justificativaAltLocalEntrega || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Indicação de Fornecedores (Informe sempre a Razão Social e o CNPJ. Acrescente outras informações se necessário)</dt>
                    <dd class="white-space-pre">{{ solicitacao.indicacaoFornec || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Observação solicitação</dt>
                    <dd class="white-space-pre">{{ solicitacao.observacaoSolCompras || '---' }}</dd>
                  </dl>
                </div>

                <div>
                  <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, index) in solicitacao.itens">
                    <h4>
                      Item #{{ index + 1 }}
                    </h4>

                    <div class="row">
                      <dl class="col-xs-6">
                        <dt>Descrição do material/serviço</dt>
                        <dd class="white-space-pre">{{ item.nomeProduto + ' - ' + item.complemento }}</dd>
                      </dl>

                      <dl class="col-xs-6">
                        <dt>Quantidade</dt>
                        <dd>{{ item.quantidade | fixar2digitos }}</dd>
                      </dl>
                    </div>

                    <div class="bs-callout bs-callout-info no-margin-top">
                      <div class="row">
                        <dl class="col-xs-4">
                          <dt>Fornecedor</dt>
                        </dl>

                        <dl class="col-xs-2">
                          <dt>Documento</dt>
                        </dl>

                        <dl class="col-xs-2">
                          <dt>Valor unitário</dt>
                        </dl>

                        <dl class="col-xs-1">
                          <dt>Frete</dt>
                        </dl>

                        <dl class="col-xs-2">
                          <dt>Valor total</dt>
                        </dl>

                        <dl class="col-xs-1">
                          <dt>Aprovar</dt>
                        </dl>
                      </div>

                      <div class="row" v-for="(pesquisa, index) in item.pesquisas">
                        <dl class="col-xs-4">
                          <dd class="white-space-pre">{{ pesquisa.nomeFornecedor }}</dd>
                        </dl>

                        <dl class="col-xs-2">
                          <dd class="white-space-pre">{{ pesquisa.documentoFornecedor }}</dd>
                        </dl>

                        <dl class="col-xs-2">
                          <dd>{{ pesquisa.valorUnitarioPesquisa | fixar2digitos }}</dd>
                        </dl>

                        <dl class="col-xs-1">
                          <dd>{{ pesquisa.valorFrete | fixar2digitos }}</dd>
                        </dl>

                        <dl class="col-xs-2">
                          <dd>{{ pesquisa.valorTotalPesquisa | fixar2digitos }}</dd>
                        </dl>

                        <div class="col-xs-1">
                          <input type='checkbox'
                                 v-model="pesquisa.pesquisaValidada"
                                 style="margin-left: 22px;"
                                 @change='marcar(pesquisa.idItemCompra, pesquisa.idPesquisa, pesquisa.pesquisaValidada)'
                                 true-value=true
                                 false-value=false>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <div class="text-center">
                    <button type="button"
                            class="btn btn-success"
                            v-tooltip="'Enviar mensagem'"
                            @click="mostrarModalMensagem(solicitacao)"
                            v-if="!configuracao.naoUtilizarMensageria">
                      <i class="fa fa-comment"></i> Mensagens
                    </button>

                    <button type="button"
                            class="btn btn-info"
                            v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                            @click="mostrarModalArquivos(solicitacao)"
                            v-if="configuracao.usarArquivosCompras">
                      <i class="fa fa-archive"></i> Arquivos
                    </button>

                    <button class="btn btn-primary"
                            v-tooltip="'Aprovar Pesquisa de Preço'"
                            @click="mostrarModalAprovarPesquisa(solicitacao)">
                      <i class="fa fa-check"></i> Aprovar Pesquisa
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/aprovar-pesquisa-preco/componentes/AprovarPesquisaPrecoRelatorio.vue